import React from 'react';
import AnimatedNumber from './AnimatedNumber'; // đầu file

class StatItem1 extends React.Component {
    render() {
        const {
            iconName,      // JSX element (icon component)
            title,         // string
            value,         // string or number
            message1,      // string
            message2,      // string
            colorValue = '#E0582C',
            colorMessage1 = '#212121',
            colorMessage2 = '#1DAA45',
            bgColor = 'rgba(255, 255, 255, 0.5)',
            bgColor2 = 'rgba(255, 255, 255, 0.5)',
            isBorder = false, // ✅ mới thêm
        } = this.props;
        const iconStyle = {
            width: 68,
            height: 68,
            objectFit:'contain'
        };
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: `linear-gradient(to right, ${bgColor}, ${bgColor2})`, // ✅ sử dụng gradient
                borderRadius: 12,
                padding: 24,
                border: isBorder ? '1px solid rgba(255, 255, 255, 1)' : 'none', // ✅ áp dụng border
                width: 'calc(100% - 48px)',  // trừ đi padding
                height: 'calc(100% - 48px)',  // trừ đi padding
                backdropFilter: 'blur(10px)', // ✅ thêm hiệu ứng blur
                WebkitBackdropFilter: 'blur(10px)', // ✅ hỗ trợ Safari
            }}>
                <div style={{ display: 'flex', alignItems: 'center',  display: 'flex', flexDirection: 'row', alignContent:'center'  }}>
                    <img src={iconName} alt="iconName" style={iconStyle} />
                    <div style={{ fontSize: 24, color: '#212121', fontWeight: 600, marginLeft: 12, textAlign:'left' }}>{title}</div>
                </div>
                <div style={{ fontSize: 64, fontWeight: 500, color: colorValue, display: 'flex', flexDirection: 'row', alignContent:'center' }}>
                    <div style={{fontFamily:'Inter28-SemiBold'}}>
                        <AnimatedNumber value={value} />
                    </div>
                    <div style={{ marginLeft: 12, alignContent:'center' }}>
                        <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage1 }}>
                            {message1}
                        </div>
                        {
                            message2 == ''? <></> : <div style={{ fontSize: 16, fontWeight: 400,  color: colorMessage2, marginTop: 4, textAlign:'left' }}>
                            {message2}
                        </div>
                        }
                        
                    </div>

                </div>

            </div>
        );
    }
}

export default StatItem1;
